/**
 * isomorphic-git expects Node's `Buffer` (see FileSystem.read). Browsers do not define it.
 */
import { Buffer } from "buffer";

const g = globalThis as typeof globalThis & { Buffer?: typeof Buffer };
if (typeof g.Buffer === "undefined") {
  g.Buffer = Buffer;
}
